import { AutenticacionService } from './autenticacion.service';
import { ErrorsService } from './tools/errors.service';
import { ValidatorService } from './tools/validator.service';
import { ConstantsService } from './constants.service';
import { Http, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';
declare var $;

@Injectable()
export class ObrasService {
  public url:string;
  public imagen_url:string;

  constructor(private http: Http, private constant: ConstantsService, private validatorService: ValidatorService, private errorService:ErrorsService, private authService: AutenticacionService){
    this.url = constant.apiURL;
    this.imagen_url = this.url + '/obras/imagen';
  }

  public getDefaultSchedule(){
    return {
      'idObras': '',
      'nombreObra': '',
      'clave': '',
      'propietario': '',
      'atencion': '',
      'statusObra':'',
      'telefono1': '',
      'fechaInicio': '',
      'porcentajeHonorarios': '',
      'direccion': '',
      'cp': '',
      'colonia': '',
      'activa': 1,
      'descripcion': '',
      'telefono2': '',
      'status': '',
      'saldoFinal': '',
      'urlImagen': ''
    };
  }

  public getObraStatusByid(id){
    return this.getObrasStatus().find(item => {
      return item.id == id
    });
  }

  public getObrasStatus(){
    return [
      {'id':1, 'nombre':'En proceso'},
      {'id':2, 'nombre':'Terminada'},
      {'id':3, 'nombre':'Otros'}
    ]
  }

  // objeto obra simple
  public getObras(){
    return this.http.get(this.url + "/obras", this.authService.getAuthHeaders());
  }

  // objeto obra select
  public getObratoSelect(preffix = '', proveedores = '') {
    //Si no trae el prefix utilizamos el servicio público de los proveedores.
    if(!preffix || preffix.length === 0){
      return this.http.get(`${this.url}/publicos/obras?select=true`, this.authService.getAuthHeaders());
    }

    //Con proveedores solo se devuelven las obras donde esos proveedores
    //tienen movimientos (formato "0-123,1-45", igual que el filtro de movimientos).
    const filtro = proveedores ? '&proveedores=' + encodeURIComponent(proveedores) : '';
    return this.http.get(this.url + preffix + '/obras?select=true' + filtro, this.authService.getAuthHeaders());
  }

  // objeto obra con inversionistas
  public getObrasWithInversionistas(page = null){
    if(page){
      return this.http.get(this.url + "/obras/inversionistas?paginate=true&page=" + page, this.authService.getAuthHeaders());  
    }

    return this.http.get(this.url + "/obras/inversionistas?paginate=true", this.authService.getAuthHeaders());
  }

  public getImageUrl(id) {
    const options = this.authService.getAuthHeaders();
    options.responseType = ResponseContentType.Blob;
    return this.http.get(this.url + '/obras/imagen?id=' + id, options);
  }


  // buscar objeto simple
  public searchObra(search){
    return this.http.get(this.url + "/obras?search=" + search, this.authService.getAuthHeaders());
  }

  // buscar objeto con inversionistas
  public searchObraWithInversionistas(search, page = null){
    if(page){
      return this.http.get(this.url + "/obras/inversionistas?paginate=true&search=" + search + "&page=" + page, this.authService.getAuthHeaders());  
    }
    return this.http.get(this.url + "/obras/inversionistas?paginate=true&search=" + search, this.authService.getAuthHeaders());
  }

  public createObra(data){
    return this.http.post(this.url + '/obras', data, this.authService.getAuthHeaders());
  }

  public updateObra(data, id){
    return this.http.put(this.url + '/obras?id=' + id, data, this.authService.getAuthHeaders());
  }

  public deleteObra(id) {
    return this.http.delete(this.url + '/obras?id=' + id, this.authService.getAuthHeaders());
  }

  public deleteObraImagen(id) {
    return this.http.delete(this.url + '/obras/imagen?id=' + id, this.authService.getAuthHeaders());
  }

  public writePermission() {
    return this.authService.hasPermission(2, true);
  }

  public canExport() {
    return this.authService.canExport();
  }

  public export(search) {
    const options = this.authService.getAuthHeaders();
    options.responseType = ResponseContentType.Blob;
    return this.http.get(this.url + '/obras/exportar?search='+search, options)
    .map((response) => {
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(response.blob());
      const contentDispositionHeader = response.headers.get('content-disposition');
      const result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
      link.download = result.replace(/"/g, '');
      document.body.appendChild(link); 
      link.click();
      setTimeout(() => {
        link.remove();
      }, 200);
    });
  }

  public validateObra(data) {
    let error = [];

    // validacion de NOMBRE DE OBRA
    if(!this.validatorService.required(data["nombreObra"])){
      error["nombreObra"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["nombreObra"], 50)){
      error["nombreObra"] = this.errorService.max(50);
    }

    // validacion de CLAVE CORTA
    if(!this.validatorService.required(data["clave"])){
      error["clave"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["clave"], 15)){
      error["clave"] = this.errorService.max(15);
    }

    // validacion de PROPIETARIO
    if(!this.validatorService.required(data["propietario"])){
      error["propietario"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["propietario"], 50)){
      error["propietario"] = this.errorService.max(50);
    }

    // validacion de ATENCIÓN
    if(!this.validatorService.required(data["atencion"])){
      error["atencion"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["atencion"], 50)){
      error["atencion"] = this.errorService.max(50);
    }
    
    // validacion de STATUS OBRA
    if(!this.validatorService.required(data["statusObra"])){
      error["statusObra"] = this.errorService.required;
    }else if(!this.validatorService.between(data["statusObra"], 1, 3)){
      error["statusObra"] = this.errorService.between(1, 3);
    }

    // validacion de TELEFONO1
    if(!this.validatorService.required(data["telefono1"])){
      error["telefono1"] = this.errorService.required;
    }else if(!this.validatorService.max(data["telefono1"], 30)){
      error["telefono1"] = this.errorService.max(30);
    }

    // validacion de TELEFONO2
    if(data["telefono2"] && !this.validatorService.max(data["telefono2"], 30)){
      error["telefono2"] = this.errorService.max(30);
    }

    // validacion de FECHA INICIO
    let now = new Date().toISOString().slice(0,10);
    let fechaInicio = $('#fechaInicio').val();
    if(!this.validatorService.required(fechaInicio) || fechaInicio == "0000-00-00"){
      error["fechaInicio"] = this.errorService.required;
    }
    else if(!this.validatorService.date(fechaInicio)){
      error["fechaInicio"] = this.errorService.generic;
    }
    else if(!this.validatorService.dateBetween(fechaInicio, "2012-10-01", now)){
      error["fechaInicio"] = this.errorService.betweenDate;
    }

    // validacion de PORCENTAJE HONORARIOS
    if(!this.validatorService.required(data["porcentajeHonorarios"])){
      error["porcentajeHonorarios"] = this.errorService.required;
    }
    else if(!this.validatorService.numeric(data["porcentajeHonorarios"])){
      error["porcentajeHonorarios"] = this.errorService.numeric;
    }
    else if(!this.validatorService.max(data["porcentajeHonorarios"].toString(), 6)){
      error["porcentajeHonorarios"] = this.errorService.max(6);
    }
    else if(!this.validatorService.maxDecimals(data["porcentajeHonorarios"], 2)){
      error["porcentajeHonorarios"] = this.errorService.generic;
    }
    
    // validacion de DIRECCION
    if(!this.validatorService.required(data["direccion"])){
      error["direccion"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["direccion"], 100)){
      error["direccion"] = this.errorService.max(100);
    }

    // validacion de CODIGO POSTAL
    if(!this.validatorService.required(data["cp"])){
      error["cp"] = this.errorService.required;
    }
    else if(!this.validatorService.numeric(data["cp"])){
      error["cp"] = this.errorService.numeric;
    }
    else if(!this.validatorService.max(data["cp"], 7)){
      error["cp"] = this.errorService.max(7);
    }

    // validacion de COLONIA
    if(!this.validatorService.required(data["colonia"])){
      error["colonia"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["colonia"], 50)){
      error["colonia"] = this.errorService.max(50);
    }

    // validacion de DESCRIPCION
    if(data["descripcion"] && !this.validatorService.max(data["descripcion"], 200)){
      error["descripcion"] = this.errorService.max(200);
    }

    //Se valida el email solo cuando es una obra de tipo emisora de facturas
    if(data["es_emisora"]){

      if(this.validatorService.required(data["email_facturacion"])){
        //Si tiene valor el campo de email, revisar que sean emails validos (pueden ser múltiples emails)
        var arregloEmails = data["email_facturacion"].split(";");
  
        arregloEmails.forEach(email => {
          if(!this.validatorService.email(email.trim())){     
            error["email_facturacion"] = "El correo o los correos no tienen un formato valido";
          }
        });
      }else{
        //El email es obligatorio cuando es de tipo facturación
        error["email_facturacion"] = this.errorService.required;
      }

    }

    return error;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/obras.service.ts